import { useEffect, useState } from "react";
import axios from "axios";
import { useLocale } from "../i18n";

// Every host that serves this SPA (preview, Emergent production, Cloudflare Worker, custom domain) routes /api to the
// backend, so calls stay same-origin (no CORS, cookies on the visible host). Local dev keeps REACT_APP_BACKEND_URL.
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const LOCAL = /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
export const API_ORIGIN = LOCAL ? BACKEND : window.location.origin;
export const api = axios.create({ baseURL: `${API_ORIGIN}/api` });

// Every public read carries the page locale so prices come back shaped for it (server-side market rules).
export const useApi = (path, params) => {
  const lang = useLocale();
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const key = JSON.stringify({ ...(params || {}), lang });

  useEffect(() => {
    let active = true;
    setState({ data: null, loading: true, error: null });
    api
      .get(path, { params: JSON.parse(key) })
      .then((r) => active && setState({ data: r.data, loading: false, error: null }))
      .catch((e) => active && setState({ data: null, loading: false, error: e }));
    return () => {
      active = false;
    };
  }, [path, key]);

  return state;
};
